import { useDispatch, useSelector } from 'react-redux';

import Tabs from './index';
import { RootState } from '../../../store';
import { setSelectedTWLanguage } from '../../../store/interface';

const options = ['ZH', 'EN'];
const labels = ['中文', 'English'];

const TWLanguagesTabs = (): JSX.Element => {
  const dispatch = useDispatch();
  const { darkMode } = useSelector((state: RootState) => state.settings);
  const { selectedTWLanguage } = useSelector((state: RootState) => state.interface);

  const select = (language: string) => {
    dispatch(setSelectedTWLanguage(language));
  };

  return (
    <Tabs
      darkMode={darkMode}
      options={options}
      labels={labels}
      selectOption={select}
      selectedOption={selectedTWLanguage}
    />
  );
};

export default TWLanguagesTabs;
